import { Component } from "react";
import dict from "../../Data/dict.json";

export default class Selection extends Component {
  render() {
    const valueOptions = this.props.column.array_templates.map(
      (option) => option.name
    );
    const parent_array_templates_key =
      this?.props?.column?.parent_array_templates_key;
    const { language, params } = this.props;

    let filtered_options = valueOptions;
    if (parent_array_templates_key) {
      const keyword = params.row?.[parent_array_templates_key]
      filtered_options = this.props.column.array_templates.filter(
        (option) => option.parent === keyword
      ).map((option) => option.name);;
    }

    return (
      <select
        className="dropdown_in_table"
        value={this.props.params.value}
        onChange={(e) => {
          let newParams = this.props.params;
          newParams.value = e.target.value;
          newParams.row.value = e.target.value;
          this.props.handleEditCellChange(
            this.props.editProperties,
            this.props.layer_id,
            newParams
          );
        }}
      >
        <option value="">{dict["Select"][language]}</option>
        {filtered_options?.map((option, index) => (
          <option key={index} value={option}>
            {option}
          </option>
        ))}
        {!filtered_options?.includes(this.props.params.value) &&
          this.props.params.value && <option>{this.props.params.value}</option>}
      </select>
    );
  }
}
